import { Web3Provider } from '@ethersproject/providers'

export function isMetaMask(provider?: Web3Provider) {
  if (provider) {
    return provider.connection?.url === 'metamask'
  }
  return false
}
